import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    dsn: "https://095d304ac06e499c85ba629e4fbcfa3b@o90177.ingest.sentry.io/6261982",
    release: "bueroforum@" + process.env.npm_package_version,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0, // We recommend adjusting this in production
});
